/**
 * View Controller
 * Handles card/grid view switching and persistence
 */
export class ViewController {
  constructor(storageService) {
    this.storage = storageService;
    this.currentView = 'card';
    this.validViews = ['card', 'grid'];
    this.portalWrapper = null;
  }

  async init() {
    this.portalWrapper = document.querySelector('.portal-wrapper');
    if (!this.portalWrapper) return;

    let savedView = await this.storage.getViewMode();
    // Fall back to 'card' if saved view is invalid
    if (!this.validViews.includes(savedView)) {
      savedView = 'card';
    }
    this.currentView = savedView;
    this._bindEvents();
    this._applyView(this.currentView);
  }

  _bindEvents() {
    const buttons = document.querySelectorAll('.portal-view-toggle .portal-view-btn');
    buttons.forEach(btn => {
      btn.addEventListener('click', async () => {
        const view = btn.dataset.view;
        if (view && view !== this.currentView && this.validViews.includes(view)) {
          await this.setView(view);
        }
      });
    });
  }

  async setView(view) {
    this.currentView = view;
    await this.storage.setViewMode(view);
    this._applyView(view);
  }

  _applyView(view) {
    if (!this.portalWrapper) return;

    // Remove all view classes
    this.portalWrapper.classList.remove('view-card', 'view-grid');

    // Add current view class
    this.portalWrapper.classList.add(`view-${view}`);

    const buttons = document.querySelectorAll('.portal-view-toggle .portal-view-btn');
    buttons.forEach(btn => {
      btn.classList.toggle('active', btn.dataset.view === view);
    });
  }
}
